import styled from 'styled-components';

export const SearchResults = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const SearchResultsSection = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.md};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SearchResultsHeader = styled.h3`
  margin: 0;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  background: ${({ theme }) => `${theme.colors.primary}10`};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1rem;
  border-radius: 4px;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const SearchResultItem = styled.div`
  padding: ${({ theme }) => theme.spacing.md};
  border-bottom: 1px solid ${({ theme }) => theme.colors.background};
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:last-child {
    border-bottom: none;
  }
`;

export const ItemInfo = styled.div`
  flex: 1;

  h4 {
    margin: 0;
    font-size: 1rem;
  }
`;

export const LocationInfo = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.9rem;
`; 